const NS = 'AustralianMapWidget';
const CLS = 'australianMapWidget';

import { utils } from '../../../../global/js/utils';

export class AustralianMapWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$states = this.$element.find('path[data-state]');

		this.$element.on('click', '[data-state]', (e) => {
			// Conceal the WYSIWYG in the australianMapPage
			let $pg = $('.australianMapPage');
			let $innerContentWrapper = $pg.find('.australianMapPage-innerContentWrapper');
			if($innerContentWrapper && $innerContentWrapper.length > 0) {
				$innerContentWrapper.siblings('.wysiwygBlock').hide();
			}

			// Scroll to the state text
			let stateName = $(e.currentTarget).data('state');
			let $stateContent = this.$element.find(`.content-area.${stateName}`);
			this.$element.find('.content-area').removeClass('active');
			let offset = $('.siteHeaderWidget').height() + 30;
			$stateContent.addClass('active');
			utils.scrollToEl($stateContent[0], 500, -offset);
		});

		// store the original fill colors
		this.$states.each((index, element) => {
			$(element).attr('data-fill', $(element).attr('fill'));
		});

		this.$element.on('mouseenter mouseleave', '[data-state]', (e) => {
			let stateName = $(e.currentTarget).data('state');
			let $statePath = this.$element.find(`path.${stateName}`);

			// reset all colors
			this.$states.each((index, element) => {
				$(element).attr('fill', $(element).attr('data-fill'));
			});

			this.originalClr = $statePath.attr('data-fill');
			this.darkerClr = utils.lightenDarkenColor(this.originalClr, -20);

			if(e.type === 'mouseenter') {
				$statePath.attr('fill', this.darkerClr);
			}
			else {
				$statePath.attr('fill', this.originalClr);
			}
		});
	}
}
